// extracted by mini-css-extract-plugin
module.exports = {"card":"eventDetails_card__1NvPB","subject":"eventDetails_subject__Rjp7e","dateInfo":"eventDetails_dateInfo__2qCrb","textInfo":"eventDetails_textInfo__2Fppf"};